import { observer } from "mobx-react";
export function withMobx(component) {
    return observer(component);
}
